import {
    useState
} from 'react';

import useOnElementDimensionChange from './useOnElementDimensionChange.js';


function useElementSize(ignoreResizes) {

    const [width, setWidth] = useState(null);
    const [height, setHeight] = useState(null);

    const {ref} = useOnElementDimensionChange(ignoreResizes, (element) => {

        if (element) {

            if (width !== element.offsetWidth) {
                setWidth(element.offsetWidth);
            }

            if (height !== element.offsetHeight) {
                setHeight(element.offsetHeight);
            }
        }
    });

    return {
        ref,
        width,
        height
    };
}

export default useElementSize;
